const DriverMonitoringEmpty = () => {
  return (
    <div className='flex flex-col items-center justify-center w-full h-full'>
      <div className='text-center'>
        <p className='text-xl font-semibold text-gray-600 mb-2'>
          No hay conductores activos
        </p>
        <p className='text-sm text-gray-500'>
          Los conductores aparecerán aquí cuando comiencen a enviar su ubicación
          GPS.
        </p>
      </div>
    </div>
  );
};

export default DriverMonitoringEmpty;
